module.exports = __webpack_public_path__ + "static/img/15.7b600e1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/4/eng/15.png
// module id = MyC5
// module chunks = 0